import { render, staticRenderFns } from "./AboutPeaj.vue?vue&type=template&id=eb5516ea&scoped=true&lang=html"
import script from "./AboutPeaj.vue?vue&type=script&lang=js"
export * from "./AboutPeaj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5516ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb5516ea')) {
      api.createRecord('eb5516ea', component.options)
    } else {
      api.reload('eb5516ea', component.options)
    }
    module.hot.accept("./AboutPeaj.vue?vue&type=template&id=eb5516ea&scoped=true&lang=html", function () {
      api.rerender('eb5516ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AboutPeaj.vue"
export default component.exports